import  Cookies from 'js-cookie';
import Global from "../utils/book_global";

export default{
   noCookie:function(){

      let t = new Date().getTime();
      let ua = navigator.userAgent;
      let uuid = hex_md5(ua + '_' + 'qvNote') + t;
      // console.log("common中",uuid);
      return uuid;
   },
   getUUID:function (){
      let uuid = Cookies.get("book_ieqx792wb66mc2");
      // console.log(coo);
      if (uuid === undefined || uuid === '') {
         uuid = this.noCookie();
         Cookies.set("book_ieqx792wb66mc2", uuid);
      }
      return uuid;
   },
   encodePath:function (message){
      let key = 'lia#edp!$xE^#@888';
      return this.encryptByDESModeEBC(key,message);
   },
   decodePath:function (message){
      let key = 'lia#edp!$xE^#@888';
      return this.decodeByDESModeEBC(key,message);
   },
   encryptByDESModeEBC:function (key,message) {
      let keyHex = CryptoJS.enc.Utf8.parse(key);
      let encrypted = CryptoJS.DES.encrypt(message, keyHex, {
         mode: CryptoJS.mode.ECB,
         padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.ciphertext.toString();
   },
   decodeByDESModeEBC:function (key,message) {
      let keyHex = CryptoJS.enc.Utf8.parse(key);
      let decrypted = CryptoJS.DES.decrypt({
         ciphertext: CryptoJS.enc.Hex.parse(message)
      }, keyHex, {
         mode: CryptoJS.mode.ECB,
         padding: CryptoJS.pad.Pkcs7
      });
      var result_value = decrypted.toString(CryptoJS.enc.Utf8);
      // console.log(result_value);
      return result_value.toString();
   },
   setLocalStorage: function (key, value, ttl_hour) {
      let date = new Date().getTime();
      let ttl_ms = ttl_hour * 1000 * 60 * 60;
      let data = { value: value, expirse: new Date(date + ttl_ms ).getTime() };
      let encodeKey = "abc#es@dp!ew$xE^#@88"
      let encode = this.encryptByDESModeEBC(encodeKey,JSON.stringify(data))
      localStorage.setItem(key,encode);
   },
   getLocalStorage: function (key) {
      let encodeKey = "abc#es@dp!ew$xE^#@88"
      let encode = localStorage.getItem(key);
      if(!encode || encode.length === 0){
         return "";
      }
      let decode = this.decodeByDESModeEBC(encodeKey,encode);
      let data = JSON.parse(decode);
      if (data !== null) {
         if (data.expirse != null && data.expirse < new Date().getTime()) {
            localStorage.removeItem(key);
         } else {
            return data.value;
         }
      }
      return null;
   },
   setSessionStorage: function (key, value, ttl_min) {
      let date = new Date().getTime();
      let ttl_ms = ttl_min * 1000 * 60;
      let data = { value: value, expirse: new Date(date + ttl_ms ).getTime() };
      let encodeKey = "abc#es@dp!ew$xE^#@88"
      let encode = this.encryptByDESModeEBC(encodeKey,JSON.stringify(data))
      sessionStorage.setItem(key,encode);
   },
   getSessionStorage: function (key) {
      let encodeKey = "abc#es@dp!ew$xE^#@88"
      let encode = sessionStorage.getItem(key);
      if(!encode || encode.length === 0){
         return "";
      }
      let decode = this.decodeByDESModeEBC(encodeKey,encode);
      let data = JSON.parse(decode);
      if (data !== null) {
         if (data.expirse != null && data.expirse < new Date().getTime()) {
            sessionStorage.removeItem(key);
         } else {
            return data.value;
         }
      }
      return null;
   },
   encodeParams:function (params,t){
      let key = Global.State.api_key + "_" + t;
      let source = JSON.stringify(params)
      return this.encryptByDESModeEBC(key,CryptoJS.enc.Utf8.parse(source));
   },
   srcFromWeather:function (){
      // let srcHost = window.location.host;
      // // alert(srcHost)
      // if(srcHost && srcHost.length > 0 && (srcHost.startsWith("note.qvkanwen.com")
      //     ||srcHost.startsWith("tbook.qvkanwen.com"))){
      // // if(srcHost && srcHost.length > 0 && srcHost.startsWith("192.168.110.110")){
      //    return true
      // }else{
      //    return false
      // }
      return true;
   },
   consoleLog:function (msg){
      let env = process.env.EVN_CONFIG;
      if(env && env === "dev" || env === "test"){
         console.log(msg);
      }
   },
   loadAd: function (id,positionId) {
      if(this.srcFromWeather()){
         let e_b_ts_1 = new Date().getTime();
         let ad = document.createElement("script");
         ad.src = "https://api.qvpublish.com/imp.js?id=" + id + "&ts=" + e_b_ts_1 + "&tp=async";
         ad.id = "e_b_sc_" + id;
         ad.type = "text/javascript";
         // let section = document.getElementById("feed_"+id);
         let section = document.getElementById(positionId);
         if (section) {
            section.innerHTML='';
            section.appendChild(ad);
         }
      }
   },
   encodeBizParams:function (params){
      let t = new Date().getTime();
      let key = 'BiZaf!ip$sJe^#pq@888'+ "_" + t;

      let encode_params = {}
      let data = this.encryptByDESModeEBC(key,JSON.stringify(params));
      encode_params.t = t;
      encode_params.data = data;
      return encode_params;
   },
   encodeBizChannelParams:function (params){
      let t = new Date().getTime()
      let key = 'Brt713Je^#pq@8FId$*#)28'+ "_" + t;
      let encode_params = {}
      let data = this.encryptByDESModeEBC(key,JSON.stringify(params));
      encode_params.t = t;
      encode_params.data = data;
      return encode_params;
   },
   randomStringForId(len) {
      len = len || 4;
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = '';
      for (var i = 0; i < len; i++) {
         pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
   }
}



// WEBPACK FOOTER //
// ./src/components/common.js